"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _actions = require("./actions");
var l = _interopRequireWildcard(require("../../core/index"));
var _index2 = require("./index");
var _actions2 = require("../../core/actions");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var LoginSignUpTabs = /*#__PURE__*/function (_React$Component) {
  _inherits(LoginSignUpTabs, _React$Component);
  var _super = _createSuper(LoginSignUpTabs);
  function LoginSignUpTabs() {
    _classCallCheck(this, LoginSignUpTabs);
    return _super.apply(this, arguments);
  }
  _createClass(LoginSignUpTabs, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        lock = _this$props.lock,
        loginLabel = _this$props.loginLabel,
        signUpLink = _this$props.signUpLink,
        signUpLabel = _this$props.signUpLabel;
      var isLogin = (0, _index2.getScreen)(lock) === 'login';
      return /*#__PURE__*/_react.default.createElement("div", {
        role: "navigation",
        className: "auth0-lock-tabs-container"
      }, /*#__PURE__*/_react.default.createElement("ul", {
        className: "auth0-lock-tabs"
      }, /*#__PURE__*/_react.default.createElement(LoginSignUpTab, {
        label: loginLabel,
        current: isLogin,
        clickHandler: this.handleLoginClick.bind(this)
      }), /*#__PURE__*/_react.default.createElement(LoginSignUpTab, {
        label: signUpLabel,
        current: !isLogin,
        clickHandler: this.handleSignUpClick.bind(this),
        clickWithHrefHandler: this.handleSignUpWithHrefClick.bind(this),
        href: signUpLink
      })));
    }
  }, {
    key: "handleLoginClick",
    value: function handleLoginClick() {
      (0, _actions.showLoginActivity)(l.id(this.props.lock));
    }
  }, {
    key: "handleSignUpClick",
    value: function handleSignUpClick() {
      if (this.props.signUpLink) {
        (0, _actions2.closeLock)(l.id(this.props.lock), true);
      }
      (0, _actions.showSignUpActivity)(l.id(this.props.lock));
    }
  }, {
    key: "handleSignUpWithHrefClick",
    value: function handleSignUpWithHrefClick() {
      (0, _actions2.closeLock)(l.id(this.props.lock), true);
    }
  }]);
  return LoginSignUpTabs;
}(_react.default.Component);
exports.default = LoginSignUpTabs;
LoginSignUpTabs.propTypes = {
  lock: _propTypes.default.object.isRequired,
  loginLabel: _propTypes.default.string.isRequired,
  signUpLabel: _propTypes.default.string.isRequired,
  signUpLink: _propTypes.default.string
};
var LoginSignUpTab = /*#__PURE__*/function (_React$Component2) {
  _inherits(LoginSignUpTab, _React$Component2);
  var _super2 = _createSuper(LoginSignUpTab);
  function LoginSignUpTab() {
    var _this;
    _classCallCheck(this, LoginSignUpTab);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      if (_this.props.href) {
        _this.props.clickWithHrefHandler();
      } else {
        e.preventDefault();
        _this.props.clickHandler();
      }
    });
    return _this;
  }
  _createClass(LoginSignUpTab, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        current = _this$props2.current,
        href = _this$props2.href,
        label = _this$props2.label;
      var className = current ? 'auth0-lock-tabs-current' : '';
      return /*#__PURE__*/_react.default.createElement("li", {
        className: className
      }, current ? /*#__PURE__*/_react.default.createElement("span", null, label) : /*#__PURE__*/_react.default.createElement("a", {
        href: href || '#',
        onClick: this.handleClick
      }, label));
    }
  }]);
  return LoginSignUpTab;
}(_react.default.Component);
